
(() => {
  "use strict";

  const SECRET_CODE = "STOVESFOREVER";
  const STORAGE_KEY = "ashRushSaveV2";

  const DEFAULT_SAVE = {
    highscores: [],
    gamesPlayed: 0,
    totalItems: 0,
    logsCaught: 0,
    pelletsCaught: 0,
    embersCaught: 0,
    goldCaught: 0,
    longestRunSeconds: 0,
    achievements: {}
  };

  const ACHIEVEMENTS = [
    { id: "first_flame", icon: "🔥", name: "First Flame", description: "Reach 100 points", check: (s, r) => r.score >= 100 },
    { id: "ash_master", icon: "🏆", name: "Ash Master", description: "Reach 1,000 points", check: (s, r) => r.score >= 1000 },
    { id: "inferno", icon: "🌋", name: "Inferno", description: "Reach 3,000 points", check: (s, r) => r.score >= 3000 },
    { id: "lumberjack", icon: "🪵", name: "Lumberjack", description: "Catch 100 logs in total", check: (s) => s.logsCaught >= 100 },
    { id: "fire_keeper", icon: "🔥", name: "Fire Keeper", description: "Catch 150 fires in total", check: (s) => s.embersCaught >= 150 },
    { id: "lucky_spark", icon: "⭐", name: "Lucky Spark", description: "Catch 10 golden sparks", check: (s) => s.goldCaught >= 10 },
    { id: "heatwave", icon: "⏱️", name: "Heatwave", description: "Survive for 90 seconds", check: (s, r) => r.duration >= 90 },
    {
      id: "stove_legend",
      icon: "👑",
      name: "Stove Legend",
      description: "Unlock every other achievement",
      check: (s) => ACHIEVEMENTS.filter(a => a.id !== "stove_legend").every(a => s.achievements[a.id])
    }
  ];

  const overlay = document.getElementById("ash-rush-overlay");
  if (!overlay) return;

  const menuScreen = document.getElementById("ash-rush-menu");
  const gameScreen = document.getElementById("ash-rush-game");
  const resultsScreen = document.getElementById("ash-rush-results");
  const canvas = document.getElementById("ash-rush-canvas");
  const ctx = canvas.getContext("2d");

  const bestScoreEl = document.getElementById("ash-rush-best-score");
  const gamesPlayedEl = document.getElementById("ash-rush-games-played");
  const achievementCountEl = document.getElementById("ash-rush-achievement-count");
  const highscoresEl = document.getElementById("ash-rush-highscores");
  const achievementsEl = document.getElementById("ash-rush-achievements");
  const scoreEl = document.getElementById("ash-rush-score");
  const livesEl = document.getElementById("ash-rush-lives");
  const hudBestEl = document.getElementById("ash-rush-hud-best");
  const countdownEl = document.getElementById("ash-rush-countdown");
  const finalScoreEl = document.getElementById("ash-rush-final-score");
  const resultTitleEl = document.getElementById("ash-rush-result-title");
  const newRecordEl = document.getElementById("ash-rush-new-record");
  const unlockedEl = document.getElementById("ash-rush-unlocked");
  const toastEl = document.getElementById("ash-rush-toast");

  let save = loadSave();
  let typedBuffer = "";
  let toastTimer = null;
  let animationFrame = null;
  let countdownTimer = null;
  let game = null;

  function loadSave() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return {
        ...DEFAULT_SAVE,
        ...(stored || {}),
        achievements: { ...DEFAULT_SAVE.achievements, ...((stored && stored.achievements) || {}) },
        highscores: Array.isArray(stored?.highscores) ? stored.highscores : []
      };
    } catch {
      return JSON.parse(JSON.stringify(DEFAULT_SAVE));
    }
  }

  function persistSave() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(save));
  }

  function getBestScore() {
    return save.highscores.length ? save.highscores[0] : 0;
  }

  function showScreen(screen) {
    [menuScreen, gameScreen, resultsScreen].forEach(el => el.classList.toggle("is-active", el === screen));
  }

  function openGameOverlay() {
    if (overlay.classList.contains("is-open")) {
      showToast("Cheat already activated.");
      return;
    }

    refreshMenu();
    showScreen(menuScreen);
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("ash-rush-lock");
    showToast("🔥 Cheat activated");
  }

  function closeGameOverlay() {
    stopGame(false);
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ash-rush-lock");
  }

  function showToast(message) {
    toastEl.textContent = message;
    toastEl.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("is-visible"), 1700);
  }

  function refreshMenu() {
    bestScoreEl.textContent = getBestScore().toLocaleString();
    gamesPlayedEl.textContent = save.gamesPlayed.toLocaleString();

    const unlockedCount = ACHIEVEMENTS.filter(a => save.achievements[a.id]).length;
    achievementCountEl.textContent = `${unlockedCount} / ${ACHIEVEMENTS.length}`;

    highscoresEl.innerHTML = "";
    for (let i = 0; i < 3; i += 1) {
      const li = document.createElement("li");
      const score = save.highscores[i];
      li.innerHTML = `<span>#${i + 1}</span><strong>${typeof score === "number" ? score.toLocaleString() : "—"}</strong>`;
      highscoresEl.appendChild(li);
    }

    achievementsEl.innerHTML = "";
    ACHIEVEMENTS.forEach(a => {
      const unlocked = Boolean(save.achievements[a.id]);
      const item = document.createElement("div");
      item.className = `ash-rush-achievement${unlocked ? " is-unlocked" : ""}`;
      item.innerHTML = `
        <div class="ash-rush-achievement-icon">${unlocked ? a.icon : "🔒"}</div>
        <div><strong>${a.name}</strong><span>${a.description}</span></div>
      `;
      achievementsEl.appendChild(item);
    });
  }

  function laneCenters() {
    return [canvas.width * 0.25, canvas.width * 0.5, canvas.width * 0.75];
  }

  function createGameState() {
    return {
      running: false,
      startedAt: 0,
      lastFrame: 0,
      spawnTimer: 0,
      score: 0,
      lives: 3,
      speedMultiplier: 1,
      lane: 1,
      targetX: laneCenters()[1],
      player: {
        x: laneCenters()[1],
        y: canvas.height - 78,
        width: 70,
        height: 62
      },
      items: [],
      particles: [],
      shake: 0,
      flash: 0,
      runStats: { logs: 0, pellets: 0, embers: 0, gold: 0 },
      specialMessageShown: { score420: false, score1337: false }
    };
  }

  function startGame() {
    stopGame(false);
    game = createGameState();
    showScreen(gameScreen);
    updateHud();
    drawScene();

    let count = 3;
    countdownEl.textContent = count;
    countdownEl.classList.add("is-active");

    countdownTimer = setInterval(() => {
      count -= 1;

      if (count > 0) countdownEl.textContent = count;
      else if (count === 0) countdownEl.textContent = "GO!";
      else {
        clearInterval(countdownTimer);
        countdownTimer = null;
        countdownEl.classList.remove("is-active");
        game.running = true;
        game.startedAt = performance.now();
        game.lastFrame = performance.now();
        animationFrame = requestAnimationFrame(gameLoop);
      }
    }, 650);
  }

  function stopGame(showResults = true) {
    if (countdownTimer) clearInterval(countdownTimer);
    countdownTimer = null;

    if (animationFrame) cancelAnimationFrame(animationFrame);
    animationFrame = null;

    if (game && game.running) {
      game.running = false;
      if (showResults) finishRun();
    }

    game = null;
  }

  function moveLane(direction) {
    if (!game?.running) return;
    const nextLane = Math.max(0, Math.min(2, game.lane + direction));
    if (nextLane === game.lane) return;
    game.lane = nextLane;
    game.targetX = laneCenters()[game.lane];
  }

  function finishRun() {
    if (!game) return;

    const duration = Math.max(0, Math.round((performance.now() - game.startedAt) / 1000));
    const oldBest = getBestScore();

    save.gamesPlayed += 1;
    save.totalItems += game.runStats.logs + game.runStats.pellets + game.runStats.embers + game.runStats.gold;
    save.logsCaught += game.runStats.logs;
    save.pelletsCaught += game.runStats.pellets;
    save.embersCaught += game.runStats.embers;
    save.goldCaught += game.runStats.gold;
    save.longestRunSeconds = Math.max(save.longestRunSeconds, duration);

    const finalScore = Math.max(0, Math.round(game.score));
    save.highscores.push(finalScore);
    save.highscores.sort((a, b) => b - a);
    save.highscores = save.highscores.slice(0, 3);

    const run = { score: finalScore, duration };
    const newlyUnlocked = [];

    ACHIEVEMENTS.forEach(a => {
      if (!save.achievements[a.id] && a.check(save, run)) {
        save.achievements[a.id] = true;
        newlyUnlocked.push(a);
      }
    });

    const legend = ACHIEVEMENTS.find(a => a.id === "stove_legend");
    if (legend && !save.achievements[legend.id] && legend.check(save, run)) {
      save.achievements[legend.id] = true;
      newlyUnlocked.push(legend);
    }

    persistSave();

    finalScoreEl.textContent = finalScore.toLocaleString();
    resultTitleEl.textContent = finalScore >= 1000 ? "That was heating up!" : finalScore >= 300 ? "Solid run!" : "The fire lives on.";
    newRecordEl.textContent = finalScore > oldBest ? "🏆 New personal high score!" : oldBest ? `Personal best: ${oldBest.toLocaleString()}` : "";

    unlockedEl.innerHTML = "";
    newlyUnlocked.forEach(a => {
      const item = document.createElement("div");
      item.className = "ash-rush-unlocked-item";
      item.textContent = `${a.icon} Achievement unlocked: ${a.name}`;
      unlockedEl.appendChild(item);
    });

    showScreen(resultsScreen);
  }

  function updateHud() {
    if (!game) return;
    scoreEl.textContent = Math.max(0, Math.round(game.score)).toLocaleString();
    livesEl.textContent = Array.from({ length: 3 }, (_, i) => i < game.lives ? "♥" : "♡").join(" ");
    hudBestEl.textContent = getBestScore().toLocaleString();
  }

  function gameLoop(timestamp) {
    if (!game?.running) return;

    const delta = Math.min((timestamp - game.lastFrame) / 1000, 0.04);
    game.lastFrame = timestamp;

    updateGame(delta, timestamp);
    drawScene();

    if (game.lives <= 0) {
      game.running = false;
      animationFrame = null;
      finishRun();
      return;
    }

    animationFrame = requestAnimationFrame(gameLoop);
  }

  function updateGame(delta, timestamp) {
    const elapsed = (timestamp - game.startedAt) / 1000;
    game.speedMultiplier = 1 + Math.min(elapsed / 55, 1.8) + Math.min(game.score / 3500, 0.8);

    game.player.x += (game.targetX - game.player.x) * Math.min(1, delta * 16);

    game.spawnTimer -= delta;
    if (game.spawnTimer <= 0) {
      spawnItem();
      game.spawnTimer = Math.max(0.3, 0.78 / game.speedMultiplier) * (0.82 + Math.random() * 0.35);
    }

    game.items.forEach(item => item.y += item.speed * game.speedMultiplier * delta);

    game.particles.forEach(p => {
      p.x += p.vx * delta;
      p.y += p.vy * delta;
      p.life -= delta;
    });

    game.particles = game.particles.filter(p => p.life > 0);
    game.shake = Math.max(0, game.shake - delta * 18);
    game.flash = Math.max(0, game.flash - delta * 4);

    for (let i = game.items.length - 1; i >= 0; i -= 1) {
      const item = game.items[i];

      if (intersects(item, game.player)) {
        collectItem(item);
        game.items.splice(i, 1);
      } else if (item.y > canvas.height + 50) {
        game.items.splice(i, 1);
      }
    }

    if (game.score >= 420 && !game.specialMessageShown.score420) {
      game.specialMessageShown.score420 = true;
      showToast("😎 The stove is feeling cool.");
    }

    if (game.score >= 1337 && !game.specialMessageShown.score1337) {
      game.specialMessageShown.score1337 = true;
      showToast("Elite heat.");
    }

    updateHud();
  }

  function spawnItem() {
    const roll = Math.random();
    let type;

    if (roll < 0.38) type = "log";
    else if (roll < 0.67) type = "ember";
    else if (roll < 0.73) type = "gold";
    else if (roll < 0.88) type = "rock";
    else type = "water";

    const sizes = {
      log: [48, 28],
      ember: [32, 32],
      gold: [32, 32],
      rock: [38, 34],
      water: [30, 40]
    };

    const lane = Math.floor(Math.random() * 3);
    const [width, height] = sizes[type];

    game.items.push({
      type,
      lane,
      x: laneCenters()[lane],
      y: -height - 12,
      width,
      height,
      speed: 145 + Math.random() * 55
    });
  }

  function collectItem(item) {
    const values = { log: 10, ember: 25, gold: 75, rock: -100, water: 0 };

    if (item.type === "water") {
      game.lives -= 1;
      game.shake = 7;
      game.flash = 0.65;
      showToast("💧 Water hit — one life lost");
      createParticles(item.x, item.y, "#5ac8fa");
      return;
    }

    if (item.type === "rock") {
      game.score = Math.max(0, game.score + values.rock);
      game.shake = 10;
      showToast("🪨 Rock hit — 100 points lost");
      createParticles(item.x, item.y, "#9aa09a");
      return;
    }

    game.score += values[item.type];
    const key = { log: "logs", ember: "embers", gold: "gold" }[item.type];
    game.runStats[key] += 1;
    createParticles(item.x, item.y, item.type === "gold" ? "#ffd84d" : "#ff9d2f");
  }

  function createParticles(x, y, color) {
    for (let i = 0; i < 10; i += 1) {
      game.particles.push({
        x,
        y,
        vx: (Math.random() - 0.5) * 130,
        vy: (Math.random() - 0.5) * 110,
        life: 0.45 + Math.random() * 0.35,
        color
      });
    }
  }

  function intersects(item, player) {
    const ix = item.x - item.width / 2;
    const iy = item.y - item.height / 2;
    const px = player.x - player.width / 2;
    const py = player.y - player.height / 2;

    return (
      ix < px + player.width &&
      ix + item.width > px &&
      iy < py + player.height &&
      iy + item.height > py
    );
  }

  function drawScene() {
    ctx.save();

    if (game?.shake) {
      const sx = (Math.random() - 0.5) * game.shake;
      const sy = (Math.random() - 0.5) * game.shake;
      ctx.translate(sx, sy);
    }

    drawBackground();

    if (game) {
      game.items.forEach(drawItem);
      game.particles.forEach(drawParticle);
      drawPlayer();
    }

    ctx.restore();

    if (game?.flash > 0) {
      ctx.fillStyle = `rgba(90, 200, 250, ${game.flash * 0.35})`;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
  }

  function drawBackground() {
    ctx.imageSmoothingEnabled = false;
    ctx.fillStyle = "#11170d";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    for (let y = 0; y < canvas.height; y += 28) {
      for (let x = (Math.floor(y / 28) % 2) * 28; x < canvas.width; x += 56) {
        ctx.fillStyle = (x + y) % 112 === 0 ? "#20291b" : "#1a2216";
        ctx.fillRect(x, y, 52, 24);
      }
    }

    const centers = laneCenters();

    centers.forEach((center, index) => {
      ctx.fillStyle = index === 1 ? "rgba(153,209,26,.055)" : "rgba(0,0,0,.16)";
      ctx.fillRect(center - 78, 0, 156, canvas.height);
    });

    ctx.setLineDash([12, 12]);
    ctx.strokeStyle = "rgba(255,255,255,.14)";
    ctx.lineWidth = 3;

    [canvas.width * 0.375, canvas.width * 0.625].forEach(x => {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.stroke();
    });

    ctx.setLineDash([]);

    ctx.fillStyle = "#2c2219";
    ctx.fillRect(0, canvas.height - 38, canvas.width, 38);

    for (let x = 0; x < canvas.width; x += 36) {
      ctx.fillStyle = x % 72 === 0 ? "#463426" : "#392b20";
      ctx.fillRect(x, canvas.height - 34, 32, 30);
    }
  }

  function drawPlayer() {
    const p = game.player;
    const x = Math.round(p.x - p.width / 2);
    const y = Math.round(p.y - p.height / 2);

    ctx.save();
    ctx.translate(x, y);

    ctx.fillStyle = "#454b44";
    ctx.fillRect(27, -18, 16, 20);
    ctx.fillStyle = "#252925";
    ctx.fillRect(30, -18, 10, 20);

    ctx.fillStyle = "#596057";
    ctx.fillRect(3, 0, 64, 7);

    ctx.fillStyle = "#262a26";
    ctx.fillRect(0, 7, 70, 45);

    ctx.fillStyle = "#3b413b";
    ctx.fillRect(4, 11, 6, 35);
    ctx.fillRect(60, 11, 6, 35);

    ctx.fillStyle = "#111411";
    ctx.fillRect(14, 14, 42, 29);

    ctx.fillStyle = "#5b3320";
    ctx.fillRect(19, 18, 31, 21);

    const flicker = Math.floor(performance.now() / 120) % 2;

    ctx.fillStyle = "#d83b00";
    ctx.fillRect(24, 28 - flicker, 20, 10);

    ctx.fillStyle = "#ff7a00";
    ctx.fillRect(28, 23 + flicker, 14, 13);

    ctx.fillStyle = "#ffd34f";
    ctx.fillRect(32, 19 - flicker, 7, 13);

    ctx.fillStyle = "#c7c7bd";
    ctx.fillRect(51, 21, 8, 4);
    ctx.fillRect(57, 21, 3, 12);

    ctx.fillStyle = "#99d11a";
    ctx.fillRect(17, 47, 7, 4);
    ctx.fillRect(29, 47, 7, 4);

    ctx.fillStyle = "#151815";
    ctx.fillRect(8, 52, 12, 10);
    ctx.fillRect(50, 52, 12, 10);

    ctx.restore();
  }

  function drawItem(item) {
    const x = Math.round(item.x - item.width / 2);
    const y = Math.round(item.y - item.height / 2);

    ctx.save();
    ctx.translate(x, y);

    if (item.type === "log") {
      ctx.fillStyle = "#6f3f23";
      ctx.fillRect(0, 5, 48, 20);
      ctx.fillStyle = "#a96535";
      ctx.fillRect(4, 8, 40, 5);
      ctx.fillStyle = "#d18a50";
      ctx.fillRect(3, 5, 7, 20);
      ctx.fillStyle = "#4d2c19";
      ctx.fillRect(38, 9, 7, 12);
    }


    if (item.type === "ember") {
      ctx.fillStyle = "#c83700";
      ctx.fillRect(8, 11, 16, 18);
      ctx.fillRect(4, 17, 24, 10);
      ctx.fillStyle = "#ff7600";
      ctx.fillRect(11, 7, 12, 18);
      ctx.fillStyle = "#ffd34f";
      ctx.fillRect(14, 3, 6, 15);
    }

    if (item.type === "gold") {
      ctx.fillStyle = "#ffbd00";
      ctx.fillRect(12, 0, 8, 32);
      ctx.fillRect(0, 12, 32, 8);
      ctx.fillRect(5, 5, 22, 22);
      ctx.fillStyle = "#fff08a";
      ctx.fillRect(12, 6, 8, 12);
    }

    if (item.type === "rock") {
      ctx.fillStyle = "#646a64";
      ctx.fillRect(4, 10, 30, 20);
      ctx.fillRect(10, 4, 19, 26);
      ctx.fillStyle = "#9ba19b";
      ctx.fillRect(12, 8, 8, 5);
    }

    if (item.type === "water") {
      ctx.fillStyle = "#3baee8";
      ctx.fillRect(11, 5, 8, 30);
      ctx.fillRect(7, 14, 16, 21);
      ctx.fillStyle = "#8cddff";
      ctx.fillRect(11, 9, 5, 15);
    }

    ctx.restore();
  }

  function drawParticle(p) {
    ctx.save();
    ctx.globalAlpha = Math.max(0, p.life);
    ctx.fillStyle = p.color;
    ctx.fillRect(Math.round(p.x), Math.round(p.y), 5, 5);
    ctx.restore();
  }

  document.addEventListener("keydown", event => {
    if (event.ctrlKey || event.metaKey || event.altKey) return;

    const key = event.key.toUpperCase();

    if (/^[A-Z]$/.test(key)) {
      typedBuffer = (typedBuffer + key).slice(-SECRET_CODE.length);

      if (typedBuffer === SECRET_CODE) {
        typedBuffer = "";
        openGameOverlay();
      }
    }

    if (!game?.running) return;

    if (["ARROWLEFT", "A"].includes(key)) {
      moveLane(-1);
      event.preventDefault();
    }

    if (["ARROWRIGHT", "D"].includes(key)) {
      moveLane(1);
      event.preventDefault();
    }

    if (key === "ESCAPE") closeGameOverlay();
  });

  document.querySelectorAll("[data-ash-close]").forEach(btn => {
    btn.addEventListener("click", closeGameOverlay);
  });

  document.getElementById("ash-rush-play").addEventListener("click", startGame);
  document.getElementById("ash-rush-play-again").addEventListener("click", startGame);

  document.getElementById("ash-rush-back-menu").addEventListener("click", () => {
    refreshMenu();
    showScreen(menuScreen);
  });

  document.getElementById("ash-rush-quit").addEventListener("click", () => {
    if (game?.running) {
      game.running = false;
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = null;
      finishRun();
      game = null;
    } else {
      refreshMenu();
      showScreen(menuScreen);
    }
  });

  document.querySelectorAll("[data-ash-direction]").forEach(button => {
    button.addEventListener("pointerdown", event => {
      event.preventDefault();
      moveLane(button.dataset.ashDirection === "left" ? -1 : 1);
    });
  });

  refreshMenu();
})();
